import Chart from "react-apexcharts";

export const dataColumnMaps = {
    goal: "expectedValue",
    result: "resultValue",
};

export function getDataFromKpiSegment(segment, column) {
    return segment?.dataRecords?.map((data) => ({
        x: String(data.year),
        y: data[column] ?? null,
    }));
    const getValue = (dataRecords, key) => dataRecords?.map((data) => ({}));
}

export function transformKpiSegmentToGoalDataSeries(segment) {
    return {
        name: "(เป้า) " + segment?.title,
        label: "(เป้า) " + segment?.title,
        type: "line",
        data: getDataFromKpiSegment(segment, dataColumnMaps.goal),
    };
}

export function transformKpiSegmentToResultDataSeries(segment) {
    return {
        name: segment?.title,
        label: segment?.title,
        type: "column",
        data: getDataFromKpiSegment(segment, dataColumnMaps.result),
    };
}

function buildDataSeries(segments) {
    let dataSeries = [];

    for (let segment of segments) {
        dataSeries.push(transformKpiSegmentToGoalDataSeries(segment));
        dataSeries.push(transformKpiSegmentToResultDataSeries(segment));
        // dataSeries.push({
        //     name: segment.title,
        //     label: segment.title,
        //     type: "column",
        //     data:
        //         segment.dataRecords?.map((data) => ({
        //             x: String(data.year),
        //             y: data.resultValue,
        //             goals: data.expectedValue
        //                 ? [
        //                       {
        //                           name: `เป้า`,
        //                           value: data.expectedValue ?? "n/a",
        //                           strokeColor: "#FF0000",
        //                       },
        //                   ]
        //                 : null,
        //         })) ?? [],
        // });
    }

    return dataSeries;
}

export function KpiBasicChart(props) {
    const { kpi } = props;

    const chartProps = {
        series: kpi?.segments ? buildDataSeries(kpi.segments) : [],
        options: {
            chart: {
                type: "line",
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false,
                },
                height: 500,
                animation: false,
                scrollablePlotArea: {
                    minHeight: 500,
                    minWidth: 400,
                },
            },
            dataLabels: {
                enabled: true,
                formatter: (value) => {
                    let number = Number.parseFloat(value);
                    if (!number) {
                        return "";
                    } else {
                        return number.toLocaleString("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        });
                    }
                },
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
                //     bar: {
                //         horizontal: false,
                //         columnWidth: "55%",
                //         endingShape: "rounded",
                //     },
            },
            // stroke: {
            //     show: true,
            //     width: 2,
            //     colors: ["transparent"],
            // },
            // markers: {
            //     size: [4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6, 4, 6],
            // },
            xaxis: {
                type: "category",
                position: "bottom",
                title: {
                    text: kpi?.timeframe?.title ? `${kpi.timeframe.title}` : "ปี",
                },
            },
            yaxis: {
                // min: 0,
                // max: 100,
                // tickAmount: 6,
                forceNiceScale: true,
                title: {
                    text: kpi?.unit ? `${kpi.unit}` : "",
                },
                labels: {
                    formatter: (value) =>
                        Number.parseFloat(value).toLocaleString("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        }),
                },
            },
            legend: {
                show: true,
                // showForSingleSeries: true,
                position: "bottom",
                horizontalAlign: "left",
            },
        },
    };

    if (kpi?.unit == "ร้อยละ") {
        chartProps.options.yaxis.min = kpi.min_value ?? 0;
        chartProps.options.yaxis.max = kpi.max_value ?? 100;
        chartProps.options.yaxis.tickAmount = kpi.graph_yaxis_tick_amount ?? 5;
    }

    return <Chart {...chartProps} />;
}

export default KpiBasicChart;
